import { Center } from "@/components/ui/center";
import React, { useEffect } from 'react';
import i18n from 'i18n-js';
import Footer from '../components/basic/Footer';
import { IconM } from '../components/media/IconsV2';

export default function Blank({ navigation }) {
    useEffect(() => {
        navigation.setOptions({ title: i18n.t('blank.title'), info: i18n.t('blank.info') })
    }, [])

    return (
        <>
            <Center className="flex-1">
                <IconM size={200} name='construction' />
            </Center>
            <Footer navigation={navigation} />
        </>
    );
}